import { formatDate } from '@disy/lib/format';

import type {
  DataConfidentialityLevelId,
  DataProtectionConfigurationDto,
  DataProtectionLabel,
  DataProtectionLabelId,
} from 'cadenza/api-client/dto/data-protection-dto';

export function formatDataProtectionLabelsShortName(dataProtectionLabels: DataProtectionLabel[]) {
  return dataProtectionLabels.length === 0 ? '–' : dataProtectionLabels.map((label) => label.shortName).join(' | ');
}

interface ObjectWithSelectedStatus {
  selected: boolean;
}

export function formatDataProtectionDeletionTime(deletionTime: string | Date) {
  const date = deletionTime instanceof Date ? deletionTime : new Date(deletionTime);
  return formatDate(date);
}

export function getLabelShortNamesWithSelected(
  config: DataProtectionConfigurationDto,
  ids: DataProtectionLabelId[],
): (DataProtectionLabel & ObjectWithSelectedStatus)[] {
  return config.protectionLabels.map((label) => ({
    selected: ids.includes(label.id),
    ...label,
  }));
}

export function formatSelectedDataProtectionLabelsShortName(
  config: DataProtectionConfigurationDto,
  ids: DataProtectionLabelId[],
) {
  const labels =
    config === undefined ? [] : getLabelShortNamesWithSelected(config, ids).filter(({ selected }) => selected);
  return formatDataProtectionLabelsShortName(labels);
}

export function formatSelectedLevelShortName(
  config: DataProtectionConfigurationDto,
  id: DataConfidentialityLevelId | undefined,
) {
  if (config === undefined) {
    return 'none';
  }
  const levels = config.confidentialityLevels;
  if (levels === undefined || levels.length === 0) {
    return 'none';
  }
  return id === undefined ? levels[0].shortName : levels.find((lev) => lev.id === id)?.shortName || levels[0].shortName;
}
